import {
  Box,
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { getColor } from "../../../style/color/color";
import TextInput from "../../../commanComponents/financialsnapshot/TextInput";
import { Close } from "@mui/icons-material";
import CustomSnackbar from "../../../commanComponents/CustomerSnackbar";

import "react-datepicker/dist/react-datepicker.css";
import { fonts } from "../../../style/fonts/fonts";
import { String } from "../../../constants/Strings";
const NPSModel = ({ Title, open, handlClose, onSubmit, values }) => {
  const [cards, setCards] = useState([{ totalHolding: "" }]);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage] = useState("");
  const handleFieldChange = (index, field, value) => {
    const newCards = [...cards];

    newCards[index][field] = value;

    setCards(newCards);
  };

  useEffect(() => {
    if (values && Object.keys(values).length > 0) {
      setCards([
        {
          totalHolding: values[0].totalHolding,
        },
      ]);
    } else {
      setCards([
        {
          totalHolding: "",
        },
      ]);
    }
  }, [values]);
  const handleSave = () => {
    onSubmit(cards);
    handlClose(false);
  };
  return (
    <Container sx={{ width: "100%", height: "100%" }}>
      <Dialog
        open={open}
        onClose={() => {
          handlClose(false);
        }}
        fullWidth
        sx={{
          width: "100%",
          maxWidth: "700px",
          height: "100%",
          overflowY: "auto",
          overflowX: "hidden",
          p: 1,
          "& .MuiPaper-root": {
            borderRadius: "16px",
          },
        }}
      >
        <DialogTitle
          sx={{
            p: 3,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: getColor.NeutralLightN60,
            textAlign: "center",
            position: "relative",
            mb: "30px",
          }}
        >
          <Typography
            sx={{
              color: getColor.NeutralDark700,
              fontSize: 16,
              fontFamily: fonts.manrope,
              fontWeight: "700",
              mt: "10px",
              flexGrow: 1,
              textAlign: "center",
            }}
          >
            {Title}
          </Typography>
          <IconButton
            onClick={() => handlClose(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 2,
              cursor: "pointer",
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>

        <DialogContent
          sx={{
            maxHeight: "400px",
            height: "100%",
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <Box
            sx={{
              mt: "40px",
              width: "100%",
              height: "100%",
            }}
          >
            {cards.map((card, index) => (
              <Box
                key={index}
                sx={{
                  width: "100%",
                  height: "100%",

                  p: 3,
                  mb: 5,
                  overflowY: "visible",
                }}
              >
                <TextInput
                  label="Total Holding"
                  value={card.totalHolding}
                  type={"number"}
                  onChange={(e) =>
                    handleFieldChange(index, "totalHolding", e.target.value)
                  }
                  inputPropss={true}
                />
              </Box>
            ))}
          </Box>
        </DialogContent>
        <DialogActions sx={{ display: "flex", flexDirection: "column" }}>
          <Button
            variant="contained"
            onClick={handleSave}
            sx={{
              color: getColor.PrimaryWhite,
              fontSize: 16,
              fontFamily: fonts.manrope,
              fontWeight: "700",
              backgroundColor: getColor.ColorButtonPrimarysurface,
              width: "200px",
              mb: "20px",
              borderRadius: 4,
              textTransform: "inherit",
            }}
          >
            {String.Dashboard.Boxes.saveButton}
          </Button>
        </DialogActions>
      </Dialog>
      <CustomSnackbar
        open={snackbarOpen}
        handleClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={"error"}
      />
    </Container>
  );
};

export default NPSModel;
